import { jsx as m } from "react/jsx-runtime";
import { createContext as i, useMemo as n } from "react";
import { toArray as s } from "../../helpers/formatting/toArray.js";
import { useControlledState as a } from "../../hooks/useControlledState.js";
const v = i(void 0), A = ({
  children: l,
  defaultSelected: u,
  multiple: c,
  onChange: t,
  selected: d
}) => {
  const { value: o, toggleValue: r } = a({
    component: "IressButtonGroup",
    defaultValue: u,
    multiple: c,
    onChange: (e) => {
      t == null || t({ selected: e });
    },
    propName: "selected",
    value: d
  }), p = n(
    () => ({
      isActive: (e) => !!(e && s(o).includes(e)),
      toggle: r,
      selected: s(o)
    }),
    [r, o]
  );
  return /* @__PURE__ */ m(v.Provider, { value: p, children: l });
};
export {
  v as ButtonGroupContext,
  A as IressButtonGroupProvider
};
